export default "__VITE_ASSET__BQoD5L_v__"